import React from 'react';
import Amplify from '@aws-amplify/core';
import awsconfig from './src/services/awsConfig.js';
import {Auth} from "@aws-amplify/auth";

declare global {
  interface Window {
    grecaptcha?: {
      enterprise?: {
        execute: (siteKey: string, options: { action: string }) => Promise<string>;
        ready: (callback: () => void) => void;
      };
    };
  }
}

export const onClientEntry = () => {
  Amplify.configure(awsconfig);
  Auth.configure(awsconfig);
};
